
import { Vue, Component, Prop } from "vue-property-decorator";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import {
  FormField,
  TextField,
  PasswordField,
  Preloader,
  FormError,
  FormBack,
  FormSubmit
} from "../components";
import { api } from "../api";
import { emailValidator } from "@/forms/service";

@Component({
  validations: {
    email: {
      maxLength: maxLength(255),
      minLength: minLength(4),
      noMatch: emailValidator,
      required
    }
  },
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    TextField,
    PasswordField,
    AmSpacing,
    AmButton,
    Preloader,
    FormError,
    FormBack,
    FormSubmit
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(Object) readonly formData!: any;

  email = this.formData.email;
  errorName = "";
  loading = false;

  DEFAULT_ERROR_NAME = "badResponseError";

  getConfigError(name: string) {
    const errorsList = this.config.errors || [];

    return errorsList[name] || this.config[this.DEFAULT_ERROR_NAME];
  }

  async onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }

    this.loading = true;
    this.errorName = "";

    try {
      const { data } = await api.forms.restorePassword({ email: this.email });
      if (data.success) {
        this.$emit("confirm");
      } else {
        this.errorName = data.errors[0];
        this.loading = false;
      }
    } catch (e) {
      this.errorName = this.DEFAULT_ERROR_NAME;
      this.loading = false;
    }
  }
}
